// The roof types names and image names can be changed from here.
// This map is used to generate the options for the React component.
// To render properly, specify a valid i18n translation and an asset name under /public/assets
export const API_ENDPOINT = '';
export const RECAPTCHA_SITE_KEY = '0x4AAAAAAA52Qle_Fto59Qwy';
export const REACT_FULLPAGE_KEY = '4N9QI-IJ356-J4K0J-30PJ9-MRNSP';

export const SOURCE = window.location.origin;

export type ThemeName = 'primary' | 'aero' | 'red'| 'curvy';

export const themes: Record<string, string> = {
	"solar-ratgeber.elektrobedarf.ch": "advisor",
	"solar-ratgeber-dev.elektrobedarf.ch": "advisor",
	"default": "primary",
};

export const supportedLanguages = [ "en", "gsw", "de", "de-CH", "de-ch", "fr", "it"];

export const roofTypesMap = [
	{i18nName: 'unselected', imgName: 'unselected.png', type: 'unselected'},
	{i18nName: 'tile', imgName: 'tile.png', type: 'normal'},
	{i18nName: 'corrugatedEternit', imgName: 'corrugated.png', type: 'normal'},
	{i18nName: 'slateEternit', imgName: 'slate.png', type: 'normal'},
	{i18nName: 'tin', imgName: 'tin.png', type: 'normal'},
	{i18nName: 'gravel', imgName: 'gravel.png', type: 'flat'},
	{i18nName: 'substrate', imgName: 'substrate.png', type: 'flat'},
	{i18nName: 'other', imgName: 'other.png', type: ''},
]

export const additionalOfferingsMap = [
	{id: 1, i18nName: 'wallbox', imgName: 'wallbox.png', i18nVerbose: 'wallboxDescription'},
	{id: 2, i18nName: 'backupPower', imgName: 'backupPower.png', i18nVerbose: 'backupPowerDescription'},
]

export const minSlope = 2;
export const maxSlope = 74;
export const minLengthWidth = 2;
export const maxLengthWidth = 8000;
export const minArea = 10;
export const maxArea = 8000;

export const directionDegrees = [
	{
		direction: 'N',
		label: 'north',
		value: 0
	},
	{
		direction: 'NE',
		label: 'northeast',
		value: 45
	},
	{
		direction: 'E',
		label: 'east',
		value: 90
	},
	{
		direction: 'SE',
		label: 'southeast',
		value: 135
	},
	{
		direction: 'S',
		label: 'south',
		value: 180
	},
	{
		direction: 'SW',
		label: 'southwest',
		value: 225
	},
	{
		direction: 'W',
		label: 'west',
		value: 270
	},
	{
		direction: 'NW',
		label: 'northwest',
		value: 315
	},
]